import type { UnifiedIconName } from '@/components/UnifiedIcon';

export interface AppShellNavItem {
  label: string;
  path: string;
  icon: UnifiedIconName;
  testId: string;
}

/** Primary sidebar navigation (protected routes). */
export const APP_SHELL_NAV_ITEMS: AppShellNavItem[] = [
  {
    label: 'Home',
    path: '/home',
    icon: 'House',
    testId: 'agents-app-shell-nav-home',
  },
  {
    label: 'Agents',
    path: '/agents',
    icon: 'SquaresFour',
    testId: 'agents-app-shell-nav-agents',
  },
  {
    label: 'Settings',
    path: '/settings',
    icon: 'Gear',
    testId: 'agents-app-shell-nav-settings',
  },
];
